import React, { useRef, useState } from "react";
import { Button } from "@material-ui/core";
import SearchBar from "./Searchbar";
import "../style.css";
import downloadWhite from "images/downloadWhite.svg";
import Filter from "./Filt";
import CustomSwitch from "../Utility/CustomSwitch";
import {
  downloadNotice,
  fetchFilterList,
  setSearch,
  setSelected,
  setSelectedRow,
} from "./action";
import { useDispatch, useSelector } from "react-redux";
import { errorToastMessage } from "utils/errorToast";
import { COMMON_MSGS } from "Constant/Messages";
import filterNew from "images/filterNew.svg";

export default function SubHeader(props) {
  const { search, selectedGstin, selected, selectedRow } = useSelector(
    (state) => state.noticeReducer
  );

  const dispatch = useDispatch();
  const debounceTimeout = useRef(null);
  const [showFilter, setShowFilter] = useState(false);

  const handleClick = async () => {
    if (!selectedGstin) {
      errorToastMessage(COMMON_MSGS.ENTER_MANDATORY_FIELDS);
      return;
    }
    await dispatch(fetchFilterList(selectedGstin));
    setShowFilter(true);
  };

  const handleClose = () => {
    setShowFilter(false);
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    dispatch(setSearch(value));
    // searchRef.current = value;

    // Debounce logic
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      props.getTableData(1, value, false);
      props.setPageNumber(1);
      console.log("Debounce Call searchStr:", value);
    }, 800);
  };

  const handleDownload = async () => {
    try {
      if (!selected || selected.length === 0) {
        errorToastMessage("Please select at least one notice to download.");
        return;
      }
      await dispatch(downloadNotice(selectedRow));
      dispatch(setSelected([]));
      dispatch(setSelectedRow([]));
    } catch (error) {
      console.log("Error in handleDownload:", error);
    }
  };
  return (
    <div className="notice-search-section">
      <div className="notice-searchbar">
        <SearchBar
          value={search}
          onChange={handleInputChange}
          placeholder="Search"
        />
      </div>

      <div className="notice-action-buttons">
        <div className="notice-button">
          <Button
            className="notice-SubHeader-button"
            variant="contained"
            color="primary"
            onClick={handleClick}
          >
            <img
              src={filterNew}
              alt="Filter"
              style={{
                width: "40px",
                height: "20px",
              }}
            />
            Filter
          </Button>
        </div>

        <div className="notice-button">
          <Button
            className="notice-SubHeader-button"
            variant="contained"
            color="primary"
            onClick={handleDownload}
          >
            <img
              src={downloadWhite}
              alt="Download"
              className="download-icon"
              style={{
                width: "15px",
                height: "15px",
                cursor: "pointer",
                marginRight: 5,
              }}
            />
            Download
          </Button>
        </div>
      </div>
      {/* <div className="notice-switch">
        <CustomSwitch />
      </div> */}

      <Filter
        open={showFilter}
        onClose={handleClose}
        getTableData={props.getTableData}
      />
    </div>
  );
}
